import { render } from "./MoneyList.vue?vue&type=template&id=28333c52"
import script from "./MoneyList.vue?vue&type=script&lang=js"
export * from "./MoneyList.vue?vue&type=script&lang=js"

import "./MoneyList.vue?vue&type=style&index=0&id=28333c52&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__